import { Button, Link } from '@mui/material';
import appSettings from 'constants/appsettings.json';

export interface SalesforceLinkProps {
  asButton?: boolean;
  salesforceContactId?: string;
  linkLabel: string;
  salesforceAccount?: string;
  salesforceInvoiceId?: string;
  salesforceInvoicePdfLink?: string;
  salesforceRecurringInvoiceId?: string;
  salesforceReferralId?: string;
  salesforceFeedbackId?: string;
  onClick?: (event: React.MouseEvent) => void;
}

export const SalesforceContactLink: React.VFC<SalesforceLinkProps> = ({ salesforceContactId, linkLabel, asButton }) => {
  const salesforceUrl = `${appSettings.salesforceUrl}lightning/r/Contact/${salesforceContactId}/view`;

  return generateLink(salesforceUrl, linkLabel, asButton);
};

export const SalesforceAccountLink: React.VFC<SalesforceLinkProps> = ({ salesforceAccount, linkLabel, asButton }) => {
  const salesforceUrl = `${appSettings.salesforceUrl}lightning/r/Account/${salesforceAccount}/view`;

  return generateLink(salesforceUrl, linkLabel, asButton);
};

export const SalesforceInvoiceLink: React.VFC<SalesforceLinkProps> = ({ salesforceInvoiceId, linkLabel, asButton }) => {
  const salesforceUrl = `${appSettings.salesforceUrl}lightning/r/fw1__Invoice__c/${salesforceInvoiceId}/view`;

  return generateLink(salesforceUrl, linkLabel, asButton);
};

export const SalesforcePdfInvoiceLink: React.VFC<SalesforceLinkProps> = ({ salesforceInvoicePdfLink, linkLabel, asButton, onClick }) => {
  const salesforceUrl = salesforceInvoicePdfLink || '';

  return generateLink(salesforceUrl, linkLabel, asButton, onClick);
};

export const SalesforceRecurringInvoiceLink: React.VFC<SalesforceLinkProps> = ({ salesforceRecurringInvoiceId, linkLabel, asButton }) => {
  const salesforceUrl = `${appSettings.salesforceUrl}lightning/r/fw1__Recurring_Invoice__c/${salesforceRecurringInvoiceId}/view`;

  return generateLink(salesforceUrl, linkLabel, asButton);
};

export const SalesforceReferralLink: React.VFC<SalesforceLinkProps> = ({ salesforceReferralId, linkLabel, asButton }) => {
  const salesforceUrl = `${appSettings.salesforceUrl}lightning/r/Referral__c/${salesforceReferralId}/view`;

  return generateLink(salesforceUrl, linkLabel, asButton);
};

export const SalesforceFeedbackLink: React.VFC<SalesforceLinkProps> = ({ salesforceFeedbackId, linkLabel, asButton }) => {
  const salesforceUrl = `${appSettings.salesforceUrl}lightning/r/Feedback__c/${salesforceFeedbackId}/view`;

  return generateLink(salesforceUrl, linkLabel, asButton);
};

const generateLink = (salesforceUrl: string, linkLabel: string, asButton?: boolean, onClick?: (event: React.MouseEvent) => void) => {
  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    if (onClick) {
      event.preventDefault();
      onClick(event);
    }
  };

  if (asButton) {
    return (
      <Button
        variant="contained"
        size="small"
        sx={{ backgroundColor: '#364152', marginLeft: '10px' }}
        href={salesforceUrl}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleClick}
      >
        {linkLabel}
      </Button>
    );
  }

  return (
    <Link underline="hover" href={salesforceUrl} target="_blank" rel="noopener noreferrer" onClick={handleClick}>
      {linkLabel}
    </Link>
  );
};
